export default __webpack_public_path__ + "static/media/lathe.73955283.jpg";